import { Injectable } from '@angular/core';
import { EnvDomainVariables } from './env.service';

@Injectable({
  providedIn: 'root',
})
export class EnvDevService {
  getDomainInfo(): EnvDomainVariables {
    return {
      _enableErrorLogging: false,
      _enableRefreshToken: false,
      isMagellan: '0',
      _env: 'dev',
      _apiUrl: 'https://dev-api.p-cis.com/api/',
      _production: true,
      _redirectUri: 'https://dev-login.p-cis.com',
      _responseType: 'token id_token',
      _issuer: 'https://opeekab2cdev.b2clogin.com/9994db7f-2dc7-4bac-bf8a-93bf04067890/v2.0/',
      _strictDiscoveryDocumentValidation: false,
      _tokenEndpoint: 'https://opeekab2cdev.b2clogin.com/opeekab2cdev.onmicrosoft.com/oauth2/v2.0/token?p=b2c_1_signin',
      _loginUrl: 'https://opeekab2cdev.b2clogin.com/opeekab2cdev.onmicrosoft.com/oauth2/v2.0/token?p=B2C_1_Signin',
      _clientId: '9994db7f-2dc7-4bac-bf8a-93bf04067890',
      _scope: 'openid profile https://opeekab2cdev.onmicrosoft.com/api/demo.read',
      _skipIssuerCheck: true,
      _clearHashAfterLogin: true,
      _oidc: true,
      _logoutUrl: 'https://opeekab2cdev.b2clogin.com/opeekab2cdev.onmicrosoft.com/B2C_1A_signin_signup_frp/oauth2/v2.0/logout?post_logout_redirect_uri=https://dev-login.p-cis.com/',
      _signInURL: 'https://opeekab2cdev.b2clogin.com/opeekab2cdev.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_signin_signup_frp',
      _signInURLSSO: 'https://opeekab2cdev.b2clogin.com/opeekab2cdev.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_SIGNIN_SIGNUP_FRP_SSO',
      _adb2cTenantUrl: 'https://opeekab2cdev.b2clogin.com/opeekab2cdev.onmicrosoft.com/oauth2/v2.0/',
      _magicLink: 'https://opeekab2cdev.b2clogin.com/opeekab2cdev.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_SIGNIN_WITH_EMAIL',
      _authEndpoint: 'https://opeekab2cdev.b2clogin.com/opeekab2cdev.onmicrosoft.com/B2C_1A_signin_signup_frp/oauth2/v2.0/authorize',
      _magicLinkScope : 'https://opeekab2cdev.b2clogin.com/opeekab2cdev.onmicrosoft.com/B2C_1A_SIGNIN_WITH_EMAIL/oauth2/v2.0/authorize',
      _launchDarklyClientId: '69120006711aa209b78d9aaf',
      _intercomAppId: 'bqgvwybf'
    };
  }
}
